import React from 'react';
import Layout from 'Nori/Layout';
import Button from 'Nori/Button';
import SplitContent from 'Custom/Split/SplitContent';
import HeroFull from 'Nori/Hero/HeroFull';
import Image from 'Nori/Image';
import RichText from 'Custom/RichText';
import HorizontalCard from 'Custom/Card/HorizontalCard';
import AjustableImage from 'Custom/AjustableImage';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import HERO_BG_IMAGE from 'Images/background/dark-blue-desktop.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/blue-bg-mobile.png';
import WHITE_MARBLE_BG_IMAGE from 'Images/misc/common-ques-desktop.png';
import WHITE_MARBLE_BG_IMAGE_MOBILE from 'Images/misc/common-ques-mobile.png';
import styles from 'styles/pages/periodChanges.module.scss';
import { Finder } from 'Custom/Finder';
import Container from 'Nori/Container';
import FAQ from 'Custom/FAQ';
import FAQHeader from 'Custom/FAQ/FAQHeader';
import CAFE_IMAGE from 'Images/people/cafe.webp';
import CAFE_IMAGE_MOBILE from 'Images/people/cafe-mobile.webp';
import CALENDAR_BLUE_IMAGE from 'Images/misc/calendar-with-circle.webp';
import { PERIOD_CHANGES_QUESTIONS } from 'Utils/questions';
import HAND_SHORT_IMAGE from 'Images/misc/hand-shadow-short.png';

const HEAD = {
  title:
    'How NEXPLANON® (etonogestrel implant) 68 mg Radiopaque May Affect Your Period',
  description:
    'Find out how NEXPLANON® (etonogestrel implant) 68 mg Radiopaque may affect your period—and what changes are normal.',
  keywords: 'Does Nexplanon stop Periods, Nexplanon Side Effects on Periods',
};

const HERO_IMAGE = {
  src: CAFE_IMAGE,
  fill: true,
  objectFit: 'cover',
  objectPosition: '70% top',
};

const HERO_MOBILE_IMAGE = {
  src: CAFE_IMAGE_MOBILE,
  fill: true,
  objectFit: 'cover',
  objectPosition: 'top center',
};

const HeroBannerContent = () => {
  return (
    <div className={styles['content-wrap']} data-qa-tag="hero-content">
      <RichText data-qa-tag="hero-text">
        <div
          className={styles.periodChangesPage}
          data-qa-tag="what-to-expect-hero"
        >
          <h4 data-qa-tag="hero-title">CHANGES TO YOUR PERIOD</h4>
          <p className={styles.middleHeroText} data-qa-tag="hero-subtitle">
            Some women experience changes to their period when on{' '}
            <span>Nexplanon</span>
          </p>
          <p className={styles.bottomHeroText} data-qa-tag="hero-content">
            These changes can be moderate to severe and, in some instances, need
            to be addressed by your doctor.
          </p>
        </div>
      </RichText>
    </div>
  );
};

export default function InsuranceCoverage() {
  return (
    <Layout
      head={HEAD}
      className={styles.periodChanges}
      data-qa-tag="splitContent-how-does-your-period-change"
    >
      <div className={styles.heroWrapper} data-qa-tag="hero-wrapper">
        <ItemBreakpoint breakpoint={'lg'}>
          <HeroFull image={HERO_BG_IMAGE} data-qa-tag="hero-desktop-image">
            <HeroBannerContent></HeroBannerContent>
          </HeroFull>
          <HeroFull
            image={HERO_BG_IMAGE_MOBILE}
            data-qa-tag="hero-mobile-image"
          >
            <HeroBannerContent></HeroBannerContent>
          </HeroFull>
        </ItemBreakpoint>
      </div>

      <SplitContent
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="how does your period change?"
        data-design-module_no="02"
        data-qa-tag="splitContent-how-does-your-period-change"
        className={styles.howPeriodChange}
      >
        <AjustableImage
          size="full"
          image={{
            src: CALENDAR_BLUE_IMAGE,
            style: { maxWidth: 292, height: 'auto' },
            alt: ''
          }}
          imageMobile={{
            src: CALENDAR_BLUE_IMAGE,
            style: { maxWidth: 144, height: 'auto' },
            alt: ''
          }}
          data-qa-tag="splitContent-calendar-image"
        />
        <>
          <RichText className={styles.copy} data-qa-tag="richText-copy">
            <h2 data-qa-tag="richText-copy-heading">
              How does your period change?
            </h2>
            <p data-qa-tag="richText-copy-paragraph">
              The most common side effect of NEXPLANON is a change in your
              normal menstrual bleeding pattern. In studies, 1 in 10 women
              stopped using NEXPLANON because of an unfavorable change in their
              bleeding pattern.
            </p>
            <p className="h3" data-qa-tag="richText-copy-h3">
              You may have:
            </p>
            <ul className="primary" data-qa-tag="richText-copy-ul">
              <li>Longer or shorter bleeding during your period</li>
              <li>No bleeding at all during the time of your period</li>
              <li>Spotting between your periods</li>
              <li>Varied amounts of time between your periods</li>
            </ul>
            <p className="h3" data-qa-tag="richText-copy-h3-2">
              When to call your doctor?
            </p>
            <p>Tell your healthcare provider right away if:</p>
            <ul className="primary" data-qa-tag="richText-copy-ul-2">
              <li>You think you may be pregnant</li>
              <li>Your menstrual bleeding is heavy and prolonged</li>
            </ul>
          </RichText>
        </>
      </SplitContent>

      <HorizontalCard
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="Already on nexplanon"
        data-design-module_no="03"
        className={styles.alreadyOnNexplanon}
      />

      <section
        className={styles.splitAccordion}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Accordion"
        data-design-module_name="Common questions"
        data-design-module_no="04"
        data-qa-tag="common-questions-section"
        style={{
          '--desktop-bg': `url(${WHITE_MARBLE_BG_IMAGE.src})`,
          '--mobile-bg': `url(${WHITE_MARBLE_BG_IMAGE_MOBILE.src})`,
        }}
      >
        <Container data-qa-tag="common-questions-section-container">
          <div
            className={styles.splitBlock}
            data-qa-tag="common-questions-block"
          >
            <div
              className={styles.content}
              data-qa-tag="common-questions-content"
            >
              <RichText data-qa-tag="common-questions-richText">
                <h2 data-qa-tag="common-questions-heading">COMMON QUESTIONS</h2>
                <h3 data-qa-tag="common-questions-heading-h3">
                  About period changes before, during, and after NEXPLANON
                </h3>

                <p className="intro" data-qa-tag="common-questions-intro">
                  Talk to your your doctor about the risks and benefits of
                  NEXPLANON.
                </p>
              </RichText>
              <div
                className={styles.ctaWrapper}
                data-qa-tag="common-questions-cta-wrapper"
              >
                <Button
                  type="primary"
                  href="/questions"
                  data-design-type="clickAction"
                  data-design-category="button_vd"
                  data-design-action="Button"
                  data-design-label="View All FAQs"
                  data-design-nori_id="Accordion"
                  data-design-module_name="Common questions"
                  data-design-module_no="04"
                  data-qa-tag="view-all-faqs-button"
                >
                  View All FAQs
                </Button>
                <Button
                  type="outlineSecondary2"
                  target="_blank"
                  rel="noopener"
                  href="/assets/static/Nexplanon-FAQ-25.pdf"
                  data-design-type="clickAction"
                  data-design-category="button_vd"
                  data-design-action="Download"
                  data-design-label="Download Questions"
                  data-design-nori_id="Accordion"
                  data-design-module_name="Common questions"
                  data-design-module_no="04"
                  data-qa-tag="download-questions-button"
                >
                  Download Questions
                </Button>
              </div>
            </div>
            <div className={styles.accordion} data-qa-tag="accordion-wrapper">
              <FAQ allowMultiple={true}>
                {PERIOD_CHANGES_QUESTIONS.map((item, index) => (
                  <React.Fragment key={`question-${index}`}>
                    <FAQHeader
                      data-design-type="clickAction"
                      data-design-label={item.title}
                      data-design-nori_id="Accordion"
                      data-design-module_name="Common questions"
                      data-design-module_no="04"
                      data-design-element_no={`${index < 9 ? '0' + (index + 1) : index + 1
                        }`}
                    >
                      {item.title}
                    </FAQHeader>
                    <div className={styles.faqContent}>{item.content}</div>
                  </React.Fragment>
                ))}
              </FAQ>
            </div>
            <p className={styles.caption} data-qa-tag="accordion-note">
              Implant not actual size.
            </p>
            <Image
              className={styles.handImage}
              src={HAND_SHORT_IMAGE}
              width={338}
              height={377}
              alt=""
              data-qa-tag="accordion-image"
            />
          </div>
        </Container>
      </section>

      <Finder data-design-module_no="05" />
    </Layout>
  );
}
